<template>
  <div class="dataSource">
    <!-- <div class="leftSource countB">
            <div class="btn_url">
                <div v-if="$store.state.modelType===0">
                    <FUrlBtn title="数据接入" :IconSize="20" path="/dataSource"></FUrlBtn>
                    <FUrlBtn title="数据准备" path="/dataSet"></FUrlBtn>
                    <FUrlBtn title="多维分析" :IconSize="20" path="/viewSet"></FUrlBtn>
                </div>
                <div v-if="$store.state.modelType===3">
                    <FUrlBtn title="查找用户" :IconSize="16" path="/findUser"></FUrlBtn>
                    <FUrlBtn title="用户列表管理" :IconSize="14" path="/userList"></FUrlBtn>
                </div>
            </div>
        </div> -->
    <v-LeftSource> </v-LeftSource>
    <div class="rightSource countB">
      <div class="rigS_til">
        <FSpanTil IconSize="20" title="数据接入列表"></FSpanTil>
        <div class="add_del">
          <FBtn @click="getDialog(0)">添加</FBtn>
          <FBtn type="4" :disabled="!tableCheck.checkList.length" @click="getRemove" class="FBtn_type_del">删除</FBtn>
        </div>
      </div>
      <div class="rigS_table" id="dataSource_table">
        <el-table :data="tableData.list" border v-loading="tableData.load" @selection-change="getTableCheck" style="width: 100%;">
          <el-table-column type="selection" align="center" class-name="checkCom" width="55">
          </el-table-column>
          <el-table-column prop="dateSourceName" :show-overflow-tooltip="true" align="center" label="数据接入" class-name="checkFirstTab">
          </el-table-column>
          <el-table-column align="center" :show-overflow-tooltip="true" label="数据形式">
            <template slot-scope="scope">
              <div>
                <span>{{getTableType(scope.row)}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" align="center" :show-overflow-tooltip="true" label="创建时间">
          </el-table-column>
          <el-table-column prop="address" align="center" :show-overflow-tooltip="true" class-name="table_xq" label="详情参数">
            <template slot-scope="scope">
              <div class="xqSpan" @click="detailsDialog(0,scope.row)">
                <span>详情参数</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" align="center" width="100" :show-overflow-tooltip="true" class-name="table_route" label="操作">
            <template slot-scope="scope">
              <div class="routeDiv">
                <FSvg title="下一步" @click.native="getRoutePush(scope.row)"></FSvg>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <FPage :pageSize="tableData.pageSize" :total="tableData.total" @page="getPage"></FPage>
      </div>
    </div>
    <!--详情参数-->
    <FDialog class="details_dialog" :dialog="details.dialog" :title="details.title" @close="detailsDialog(1)" moveWidth="30%">
      <div class="details_dialog_form">
        <el-form ref="details_mysql" :model="details.form.mysql" :rules="details.rules.mysql" label-width="125px" v-show="details.type===0">
          <el-form-item label="数据接入名称：" prop="DateSourceName">
            <el-input v-model="details.form.mysql.DateSourceName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="服务器：" prop="Server">
            <el-input v-model="details.form.mysql.Server" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="端口：" prop="Port">
            <el-input v-model="details.form.mysql.Port" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="用户名：" prop="UserName">
            <el-input v-model="details.form.mysql.UserName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="Password">
            <el-input v-model="details.form.mysql.Password" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="库名：" prop="Catalog">
            <el-input v-model="details.form.mysql.Catalog" :readonly="!details.upd"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="details_server" :model="details.form.server" :rules="details.rules.server" label-width="125px" v-show="details.type===1">
          <el-form-item label="数据接入名称：" prop="DateSourceName">
            <el-input v-model="details.form.server.DateSourceName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="服务器：" prop="Server">
            <el-input v-model="details.form.server.Server" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="端口：" prop="Port">
            <el-input v-model="details.form.server.Port" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="用户名：" prop="UserName">
            <el-input v-model="details.form.server.UserName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="Password">
            <el-input v-model="details.form.server.Password" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="库名：" prop="Catalog">
            <el-input v-model="details.form.server.Catalog" :readonly="!details.upd"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="details_oracle" :model="details.form.oracle" :rules="details.rules.oracle" label-width="125px" v-show="details.type===2">
          <el-form-item label="数据接入名称：" prop="DateSourceName">
            <el-input v-model="details.form.oracle.DateSourceName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="服务器：" prop="Server">
            <el-input v-model="details.form.oracle.Server" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="服务器名/SID：" prop="Catalog">
            <el-input v-model="details.form.oracle.Catalog" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="端口：" prop="Port">
            <el-input v-model="details.form.oracle.Port" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="用户名：" prop="UserName">
            <el-input v-model="details.form.oracle.UserName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="Password">
            <el-input v-model="details.form.oracle.Password" :readonly="!details.upd"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="details_excel" :model="details.form.excel" :rules="details.rules.excel" label-width="125px" v-show="details.type===3">
          <el-form-item label="数据接入名称：" prop="DateSourceName">
            <el-input v-model="details.form.excel.DateSourceName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="文件路径：" prop="filePath" v-if="!details.upd">
            <el-input v-model="details.form.excel.filePath" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="文件名称：" prop="FileName" v-if="!details.upd">
            <el-input v-model="details.form.excel.FileName" :readonly="!details.upd"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="details_csv" :model="details.form.csv" :rules="details.rules.csv" label-width="125px" v-show="details.type===6">
          <el-form-item label="数据接入名称：" prop="DateSourceName">
            <el-input v-model="details.form.csv.DateSourceName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="文件路径：" prop="filePath" v-if="!details.upd">
            <el-input v-model="details.form.csv.filePath" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="文件名称：" prop="FileName" v-if="!details.upd">
            <el-input v-model="details.form.csv.FileName" :readonly="!details.upd"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="details_DaMeng" :model="details.form.DaMeng" :rules="details.rules.DaMeng" label-width="125px" v-show="details.type===4">
          <el-form-item label="数据接入名称：" prop="DateSourceName">
            <el-input v-model="details.form.DaMeng.DateSourceName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="服务器：" prop="Server">
            <el-input v-model="details.form.DaMeng.Server" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="端口：" prop="Port">
            <el-input v-model="details.form.DaMeng.Port" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="用户名：" prop="UserName">
            <el-input v-model="details.form.DaMeng.UserName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="Password">
            <el-input v-model="details.form.DaMeng.Password" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="库名：" prop="Catalog">
            <el-input v-model="details.form.DaMeng.Catalog" :readonly="!details.upd"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="details_KingBase" :model="details.form.KingBase" :rules="details.rules.KingBase" label-width="125px" v-show="details.type===5">
          <el-form-item label="数据接入名称：" prop="DateSourceName">
            <el-input v-model="details.form.KingBase.DateSourceName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="服务器：" prop="Server">
            <el-input v-model="details.form.KingBase.Server" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="端口：" prop="Port">
            <el-input v-model="details.form.KingBase.Port" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="用户名：" prop="UserName">
            <el-input v-model="details.form.KingBase.UserName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="Password">
            <el-input v-model="details.form.KingBase.Password" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="库名：" prop="Catalog">
            <el-input v-model="details.form.KingBase.Catalog" :readonly="!details.upd"></el-input>
          </el-form-item>
        </el-form>
        <div style="padding: 0 20px;margin-top: 10px;width: 100%" v-if="details.upd&&details.type===3">
          <el-upload class="upload-demo" action="" :limit="1" accept=".xls,.xlsx" :before-upload="getDetailsUpload">
            <el-button size="small" type="primary">点击上传</el-button>
            <span style="margin-left: 10px;letter-spacing: 1px">{{details.form.excel.file.name}}</span>
          </el-upload>
        </div>
        <div style="padding: 0 20px;margin-top: 10px;width: 100%" v-if="details.upd&&details.type===6">
          <el-upload class="upload-demo" action="" :limit="1" accept=".csv" :before-upload="getDetailsUpload2">
            <el-button size="small" type="primary">点击上传</el-button>
            <span style="margin-left: 10px;letter-spacing: 1px">{{details.form.csv.file.name}}</span>
          </el-upload>
        </div>
        <el-form ref="details_Hive" :model="details.form.Hive" :rules="details.rules.Hive" label-width="125px" v-show="details.type===7">
          <el-form-item label="数据接入名称：" prop="DateSourceName">
            <el-input v-model="details.form.Hive.DateSourceName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="服务器：" prop="Server">
            <el-input v-model="details.form.Hive.Server" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="端口：" prop="Port">
            <el-input v-model="details.form.Hive.Port" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="用户名：" prop="UserName">
            <el-input v-model="details.form.Hive.UserName" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="Password">
            <el-input v-model="details.form.Hive.Password" :readonly="!details.upd"></el-input>
          </el-form-item>
          <el-form-item label="库名：" prop="Catalog">
            <el-input v-model="details.form.Hive.Catalog" :readonly="!details.upd"></el-input>
          </el-form-item>
        </el-form>
        <div class="btnRight">
          <FBtn type="3" class="btnTest" @click="getDetailsUpd" v-if="!details.upd">修改</FBtn>
          <FBtn type="1" class="btnTest" @click="getFormTest(1)" v-if="details.upd">开发测试</FBtn>
          <FBtn type="1" class="btnTest" @click="getDetailCancel" v-if="details.upd">重置</FBtn>
          <FBtn type="2" class="btnTest" @click="getDetailTestUpd" v-if="details.upd">连接</FBtn>
        </div>
      </div>
    </FDialog>
    <FDialog class="details_dialog" :dialog="add.dialog" :title="add.title" moveWidth="576px" @close="getDialog(1)">
      <div class="form">
        <div class="checkForm">
          <div class="database">
            <div class="kind">
              <div>文本文件</div>
              <el-radio-group v-model="uploadForm.radio" @change="getRadioType">
                <el-radio :label="3">
                  <span class="iconfont icon-excel"></span>
                  EXCEL
                </el-radio>
                <el-radio :label="6">
                  <span class="iconfont icon-CSV"></span>
                  CSV
                </el-radio>
              </el-radio-group>
            </div>
            <div class="kind">
              <div>数据库</div>
              <el-radio-group v-model="uploadForm.radio" @change="getRadioType">
                <el-radio :label="0">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-connection-Other"></use>
                  </svg>
                  MYSQL
                </el-radio>
                <el-radio :label="1">
                  <!-- <span class="iconfont icon-db_mysql_server"></span> -->
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-db_mysql_server"></use>
                  </svg>
                  SQL SERVE
                </el-radio>
                <el-radio :label="2">
                  <!-- <span class="iconfont icon-oracle"></span> -->
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-oracle"></use>
                  </svg>
                  ORACLE
                </el-radio>
                <!-- <el-radio :label="7" disabled>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-tidb"></use>
                  </svg>
                  TIBD
                </el-radio> -->
                <el-radio :label="4">
                  <!-- <span class="iconfont icon-damengshujuku"></span> -->
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-damengshujuku"></use>
                  </svg>
                  达梦
                </el-radio>
                <el-radio :label="5">
                  <!-- <span class="iconfont icon-rendajincang"></span> -->
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-rendajincang"></use>
                  </svg>
                  金仓
                </el-radio>
                <!-- <el-radio :label="8" disabled>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-hadoop"></use>
                  </svg>
                  Hadoop
                </el-radio> -->
                <el-radio :label="7">
                  <!-- <span class="iconfont icon-Hive"></span> -->
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-Hive"></use>
                  </svg>
                  Hive
                </el-radio>
              </el-radio-group>
            </div>
            <!-- <div class="kind">
              <div>离线通用数据</div>
              <el-radio-group v-model="uploadForm.radio" @change="getRadioType">
                <el-radio :label="10" disabled>
                  <span class="iconfont icon-renkouzengchangshuai"></span>
                  人口增长率
                </el-radio>
                <el-radio :label="11" disabled>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-GlobalGDPquanyuGDP"></use>
                  </svg>
                  全国地区GDP
                </el-radio>
              </el-radio-group>
            </div> -->
          </div>
        </div>
        <div class="countForm">
          <el-form ref="form_mysql" :model="uploadForm.mysql" :rules="ruleForm.mysql" label-width="125px" v-show="uploadForm.radio===0">
            <el-form-item label="服务器：" prop="Server">
              <el-input v-model="uploadForm.mysql.Server"></el-input>
            </el-form-item>
            <el-form-item label="端口：" prop="port">
              <el-input v-model="uploadForm.mysql.port"></el-input>
            </el-form-item>
            <el-form-item label="用户名：" prop="userid">
              <el-input v-model="uploadForm.mysql.userid"></el-input>
            </el-form-item>
            <el-form-item label="密码：" prop="password">
              <el-input v-model="uploadForm.mysql.password"></el-input>
            </el-form-item>
            <el-form-item label="库名：" prop="Catalog">
              <el-input v-model="uploadForm.mysql.Catalog"></el-input>
            </el-form-item>
          </el-form>
          <el-form ref="form_server" :model="uploadForm.server" :rules="ruleForm.server" label-width="125px" v-show="uploadForm.radio===1">
            <el-form-item label="服务器：" prop="Server">
              <el-input v-model="uploadForm.server.Server"></el-input>
            </el-form-item>
            <el-form-item label="端口：" prop="port">
              <el-input v-model="uploadForm.server.port"></el-input>
            </el-form-item>
            <el-form-item label="用户名：" prop="userid">
              <el-input v-model="uploadForm.server.userid"></el-input>
            </el-form-item>
            <el-form-item label="密码：" prop="password">
              <el-input v-model="uploadForm.server.password"></el-input>
            </el-form-item>
            <el-form-item label="库名：" prop="Catalog">
              <el-input v-model="uploadForm.server.Catalog"></el-input>
            </el-form-item>
          </el-form>
          <el-form ref="form_oracle" :model="uploadForm.oracle" :rules="ruleForm.oracle" label-width="125px" v-show="uploadForm.radio===2">
            <el-form-item label="服务器：" prop="Server">
              <el-input v-model="uploadForm.oracle.Server"></el-input>
            </el-form-item>
            <el-form-item label="服务器名/SID：" prop="Catalog">
              <el-input v-model="uploadForm.oracle.Catalog"></el-input>
            </el-form-item>
            <el-form-item label="端口：" prop="port">
              <el-input v-model="uploadForm.oracle.port"></el-input>
            </el-form-item>
            <el-form-item label="用户名：" prop="userid">
              <el-input v-model="uploadForm.oracle.userid"></el-input>
            </el-form-item>
            <el-form-item label="密码：" prop="password">
              <el-input v-model="uploadForm.oracle.password"></el-input>
            </el-form-item>
          </el-form>
          <div class="type4_upload" v-show="uploadForm.radio===3">
            <el-upload class="upload-demo" action="" :limit="1" accept=".xls,.xlsx" :before-upload="getUploadBefore">
              <el-button size="small" type="primary">点击上传</el-button>
              <span style="margin-left: 10px;letter-spacing: 1px">{{uploadForm.excel.file.name}}</span>
            </el-upload>
          </div>
          <div class="type4_upload" v-show="uploadForm.radio===6">
            <el-upload class="upload-demo" action="" :limit="1" accept=".csv" :before-upload="getUploadBefore2">
              <el-button size="small" type="primary">点击上传</el-button>
              <span style="margin-left: 10px;letter-spacing: 1px">{{uploadForm.csv.file.name}}</span>
            </el-upload>
          </div>
          <el-form ref="form_DaMeng" :model="uploadForm.DaMeng" :rules="ruleForm.DaMeng" label-width="125px" v-show="uploadForm.radio===4">
            <el-form-item label="服务器：" prop="Server">
              <el-input v-model="uploadForm.DaMeng.Server"></el-input>
            </el-form-item>
            <el-form-item label="端口：" prop="port">
              <el-input v-model="uploadForm.DaMeng.port"></el-input>
            </el-form-item>
            <el-form-item label="用户名：" prop="userid">
              <el-input v-model="uploadForm.DaMeng.userid"></el-input>
            </el-form-item>
            <el-form-item label="密码：" prop="password">
              <el-input v-model="uploadForm.DaMeng.password"></el-input>
            </el-form-item>
            <el-form-item label="库名：" prop="Catalog">
              <el-input v-model="uploadForm.DaMeng.Catalog"></el-input>
            </el-form-item>
          </el-form>
          <el-form ref="form_KingBase" :model="uploadForm.KingBase" :rules="ruleForm.KingBase" label-width="125px" v-show="uploadForm.radio===5">
            <el-form-item label="服务器：" prop="Server">
              <el-input v-model="uploadForm.KingBase.Server"></el-input>
            </el-form-item>
            <el-form-item label="端口：" prop="port">
              <el-input v-model="uploadForm.KingBase.port"></el-input>
            </el-form-item>
            <el-form-item label="用户名：" prop="userid">
              <el-input v-model="uploadForm.KingBase.userid"></el-input>
            </el-form-item>
            <el-form-item label="密码：" prop="password">
              <el-input v-model="uploadForm.KingBase.password"></el-input>
            </el-form-item>
            <el-form-item label="库名：" prop="Catalog">
              <el-input v-model="uploadForm.KingBase.Catalog"></el-input>
            </el-form-item>
          </el-form>
          <el-form ref="form_Hive" :model="uploadForm.Hive" :rules="ruleForm.Hive" label-width="125px" v-show="uploadForm.radio===7">
            <el-form-item label="服务器：" prop="Server">
              <el-input v-model="uploadForm.Hive.Server"></el-input>
            </el-form-item>
            <el-form-item label="端口：" prop="port">
              <el-input v-model="uploadForm.Hive.port"></el-input>
            </el-form-item>
            <el-form-item label="用户名：" prop="userid">
              <el-input v-model="uploadForm.Hive.userid"></el-input>
            </el-form-item>
            <el-form-item label="密码：" prop="password">
              <el-input v-model="uploadForm.Hive.password"></el-input>
            </el-form-item>
            <el-form-item label="库名：" prop="Catalog">
              <el-input v-model="uploadForm.Hive.Catalog"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="btnCenter">
          <FBtn type="5" class="btnCancel" @click="getFormTest(0)">测试数据接入</FBtn>
          <FBtn type="5" class="btnCancel" @click="getRadioType">重置</FBtn>
          <FBtn type="6" class="btnTest" @click="getTestSave">连接</FBtn>
        </div>
      </div>
    </FDialog>
  </div>
</template>
<script>
/**
 @author xiaoye
 @date 2020/4/7 2:53 下午
 */
import {
  MySqlConnText,
  SqlServerConnText,
  OraConnText,
  ExcelConnTestAsync,
  SaveDataSource,
  GetDataSourceTableList,
  GetDataSourceByDataSourceId,
  RemoveDataSource,
  GetDataSourceNameVerify,
  DaMengConnText,
  KingBaseConnText,
} from '@/assets/axios/dataUpload/dataSource'
import { getDemo } from '@/assets/axios/commAxios'
// import  '../../../../assets/common/icon/iconfont'
// import vLeftSource from '../../../../components/LeftSource/LeftSource.vue'
import '@/assets/common/icon/iconfont.js'
import vLeftSource from '@/components/LeftSource/LeftSource.vue'
import '@/assets/common/icon/iconfont.css'

export default {
  name: 'dataSource',
  components: {
    vLeftSource,
  },
  props: {},
  data() {
    return {
      //上传数据 表单
      uploadForm: {
        radio: 0,
        mysql: {
          Server: '',
          port: '',
          userid: '',
          password: '',
          Catalog: '',
        },
        server: {
          Server: '',
          port: '',
          userid: '',
          password: '',
          Catalog: '',
        },
        oracle: {
          Server: '',
          Catalog: '',
          port: '',
          userid: '',
          password: '',
        },
        excel: {
          file: {},
          filePath: '',
          fileName: ''
        },
        DaMeng: {
          Server: '',
          port: '',
          userid: '',
          password: '',
          Catalog: '',
        },
        KingBase: {
          Server: '',
          port: '',
          userid: '',
          password: '',
          Catalog: '',
        },
        csv: {
          file: {},
          filePath: '',
          fileName: ''
        },
        Hive: {
          Server: '',
          port: '',
          userid: '',
          password: '',
          Catalog: '',
        },
      },
      //验证
      ruleForm: {
        mysql: {
          Server: { required: true, message: '服务器不能为空', trigger: 'blur' },
          port: { required: true, message: '端口不能为空', trigger: 'blur' },
          userid: { required: true, message: '用户名不能为空', trigger: 'blur' },
          password: { required: true, message: '密码不能为空', trigger: 'blur' },
          Catalog: { required: true, message: '库名不能为空', trigger: 'blur' },
        },
        server: {
          Server: { required: true, message: '服务器不能为空', trigger: 'blur' },
          port: { required: true, message: '端口不能为空', trigger: 'blur' },
          userid: { required: true, message: '用户名不能为空', trigger: 'blur' },
          password: { required: true, message: '密码不能为空', trigger: 'blur' },
          Catalog: { required: true, message: '库名不能为空', trigger: 'blur' },
        },
        oracle: {
          Server: { required: true, message: '服务器不能为空', trigger: 'blur' },
          Catalog: { required: true, message: '服务器名/SID不能为空', trigger: 'blur' },
          port: { required: true, message: '端口不能为空', trigger: 'blur' },
          userid: { required: true, message: '用户名不能为空', trigger: 'blur' },
          password: { required: true, message: '密码不能为空', trigger: 'blur' },
        },
        DaMeng: {
          Server: { required: true, message: '服务器不能为空', trigger: 'blur' },
          port: { required: true, message: '端口不能为空', trigger: 'blur' },
          userid: { required: true, message: '用户名不能为空', trigger: 'blur' },
          password: { required: true, message: '密码不能为空', trigger: 'blur' },
          Catalog: { required: true, message: '库名不能为空', trigger: 'blur' },
        },
        KingBase: {
          Server: { required: true, message: '服务器不能为空', trigger: 'blur' },
          port: { required: true, message: '端口不能为空', trigger: 'blur' },
          userid: { required: true, message: '用户名不能为空', trigger: 'blur' },
          password: { required: true, message: '密码不能为空', trigger: 'blur' },
          Catalog: { required: true, message: '库名不能为空', trigger: 'blur' },
        },
        Hive: {
          Server: { required: true, message: '服务器不能为空', trigger: 'blur' },
          port: { required: true, message: '端口不能为空', trigger: 'blur' },
          userid: { required: true, message: '用户名不能为空', trigger: 'blur' },
          password: { required: true, message: '密码不能为空', trigger: 'blur' },
          Catalog: { required: true, message: '库名不能为空', trigger: 'blur' },
        }
      },
      //表格数据
      tableData: {
        list: [],
        pageIndex: 1,
        pageSize: 10,
        total: 10,
        load: true
      },
      //表格选择
      tableCheck: {
        checkList: []
      },
      //添加
      add: {
        dialog: false,
        title: '上传数据',
        type: 0,
      },
      //详情
      details: {
        dialog: false,
        title: '',
        type: 0,
        upd: false,
        oldStr: '',
        //表单
        form: {
          mysql: {
            ID: '',
            Type: 1,
            DateSourceName: '',
            UserName: '',
            Password: '',
            Server: '',
            Port: '',
            Catalog: '',
          },
          server: {
            ID: '',
            Type: 2,
            DateSourceName: '',
            UserName: '',
            Password: '',
            Server: '',
            Port: '',
            Catalog: '',
          },
          oracle: {
            ID: '',
            Type: 3,
            DateSourceName: '',
            UserName: '',
            Password: '',
            Server: '',
            Port: '',
            Catalog: '',
          },
          excel: {
            ID: '',
            Type: 0,
            DateSourceName: '',
            FileName: '',
            file: {},
            filePath: ''
          },
          DaMeng: {
            ID: '',
            Type: 4,
            DateSourceName: '',
            UserName: '',
            Password: '',
            Server: '',
            Port: '',
            Catalog: '',
          },
          KingBase: {
            ID: '',
            Type: 5,
            DateSourceName: '',
            UserName: '',
            Password: '',
            Server: '',
            Port: '',
            Catalog: '',
          },
          csv: {
            ID: '',
            Type: 6,
            DateSourceName: '',
            FileName: '',
            file: {},
            filePath: ''
          },
          Hive: {
            ID: '',
            Type: 7,
            DateSourceName: '',
            UserName: '',
            Password: '',
            Server: '',
            Port: '',
            Catalog: '',
          },
        },
        //验证
        rules: {
          mysql: {
            DateSourceName: { required: true, message: '数据接入名称不能为空', trigger: 'blur' },
            Server: { required: true, message: '服务器不能为空', trigger: 'blur' },
            Port: { required: true, message: '端口不能为空', trigger: 'blur' },
            UserName: { required: true, message: '用户名不能为空', trigger: 'blur' },
            Password: { required: true, message: '密码不能为空', trigger: 'blur' },
            Catalog: { required: true, message: '库名不能为空', trigger: 'blur' },
          },
          server: {
            DateSourceName: { required: true, message: '数据接入名称不能为空', trigger: 'blur' },
            Server: { required: true, message: '服务器不能为空', trigger: 'blur' },
            Port: { required: true, message: '端口不能为空', trigger: 'blur' },
            UserName: { required: true, message: '用户名不能为空', trigger: 'blur' },
            Password: { required: true, message: '密码不能为空', trigger: 'blur' },
            Catalog: { required: true, message: '库名不能为空', trigger: 'blur' },
          },
          oracle: {
            DateSourceName: { required: true, message: '数据接入名称不能为空', trigger: 'blur' },
            Server: { required: true, message: '服务器名/SID不能为空', trigger: 'blur' },
            Port: { required: true, message: '端口不能为空', trigger: 'blur' },
            UserName: { required: true, message: '用户名不能为空', trigger: 'blur' },
            Password: { required: true, message: '密码不能为空', trigger: 'blur' },
            Catalog: { required: true, message: '库名不能为空', trigger: 'blur' },
          },
          excel: {
            DateSourceName: { required: true, message: '数据接入名称不能为空', trigger: 'blur' },
            // filePath: {required: true, message: '文件路径不能为空', trigger: 'blur'},
          },
          DaMeng: {
            DateSourceName: { required: true, message: '数据接入名称不能为空', trigger: 'blur' },
            Server: { required: true, message: '服务器不能为空', trigger: 'blur' },
            Port: { required: true, message: '端口不能为空', trigger: 'blur' },
            UserName: { required: true, message: '用户名不能为空', trigger: 'blur' },
            Password: { required: true, message: '密码不能为空', trigger: 'blur' },
            Catalog: { required: true, message: '库名不能为空', trigger: 'blur' },
          },
          KingBase: {
            DateSourceName: { required: true, message: '数据接入名称不能为空', trigger: 'blur' },
            Server: { required: true, message: '服务器不能为空', trigger: 'blur' },
            Port: { required: true, message: '端口不能为空', trigger: 'blur' },
            UserName: { required: true, message: '用户名不能为空', trigger: 'blur' },
            Password: { required: true, message: '密码不能为空', trigger: 'blur' },
            Catalog: { required: true, message: '库名不能为空', trigger: 'blur' },
          },
          csv: {
            DateSourceName: { required: true, message: '数据接入名称不能为空', trigger: 'blur' },
            // filePath: {required: true, message: '文件路径不能为空', trigger: 'blur'},
          },
          Hive: {
            DateSourceName: { required: true, message: '数据接入名称不能为空', trigger: 'blur' },
            Server: { required: true, message: '服务器不能为空', trigger: 'blur' },
            Port: { required: true, message: '端口不能为空', trigger: 'blur' },
            UserName: { required: true, message: '用户名不能为空', trigger: 'blur' },
            Password: { required: true, message: '密码不能为空', trigger: 'blur' },
            Catalog: { required: true, message: '库名不能为空', trigger: 'blur' },
          },
        },
      },
    }
  },
  methods: {
    //添加弹框
    getDialog(type) {
      if (type === 0) {
        this.add.dialog = true;
      }
      else if (type === 1) {
        this.add.dialog = false;
      }

    },
    resize() {

    },
    //获取数据
    init() {
      this.getDataSoureList();
    },
    //清空数据
    getRadioType() {
      this.uploadForm.mysql = {
        Server: '',
        port: '',
        userid: '',
        password: '',
        Catalog: '',
      };
      this.uploadForm.server = {
        Server: '',
        port: '',
        userid: '',
        password: '',
        Catalog: '',
      };
      this.uploadForm.oracle = {
        Server: '',
        Catalog: '',
        port: '',
        userid: '',
        password: '',
      };
      this.uploadForm.DaMeng = {
        Server: '',
        Catalog: '',
        port: '',
        userid: '',
        password: '',
      };
      this.uploadForm.KingBase = {
        Server: '',
        Catalog: '',
        port: '',
        userid: '',
        password: '',
      };
      this.uploadForm.Hive = {
        Server: '',
        Catalog: '',
        port: '',
        userid: '',
        password: '',
      };
      this.uploadForm.excel.file = {};
      this.uploadForm.csv.file = {};
      this.$refs['form_mysql'].clearValidate();
      this.$refs['form_server'].clearValidate();
      this.$refs['form_oracle'].clearValidate();
      this.$refs['form_DaMeng'].clearValidate();
      this.$refs['form_KingBase'].clearValidate();
      this.$refs['form_Hive'].clearValidate();
    },
    //开发测试
    getFormTest(type) {
      if (type === 0) {
        if (this.uploadForm.radio === 0) {
          this.uploadForm.mysql = {
            Server: '175.27.191.97',
            port: '3306',
            userid: 'root',
            password: 'zbys@2021',
            Catalog: 'demo',
          };
        } else if (this.uploadForm.radio === 1) {
          this.uploadForm.server = {
            Server: '175.27.191.97',
            port: '1433',
            userid: 'sa',
            password: 'ZBYS@2021',
            Catalog: 'DB_On_Trial',
          };
        } else if (this.uploadForm.radio === 2) {
          this.uploadForm.oracle = {
            Server: '175.27.191.97',
            port: '1521',
            userid: 'scott',
            password: 'Oracle11g',
            Catalog: 'DB_On_Trial',
          };
        }
        if (this.uploadForm.radio === 4) {
          this.uploadForm.DaMeng = {
            Server: '175.27.191.97',
            port: '5236',
            userid: 'SYSDBA',
            password: 'ZBYS@2021',
            Catalog: 'DB_On_Trial',
          };
        }
        if (this.uploadForm.radio === 5) {
          this.uploadForm.KingBase = {
            Server: '175.27.191.97',
            port: '54321',
            userid: 'system',
            password: 'ZBYS@2021',
            Catalog: 'DB_On_Trial',
          };
        }
        if (this.uploadForm.radio === 7) {
          this.uploadForm.Hive = {
            Server: '175.27.191.97',
            port: '54321',
            userid: 'system',
            password: 'ZBYS@2021',
            Catalog: 'DB_On_Trial',
          };
        }
        this.$refs['form_mysql'].clearValidate();
        this.$refs['form_server'].clearValidate();
        this.$refs['form_oracle'].clearValidate();
        this.$refs['form_DaMeng'].clearValidate();
        this.$refs['form_KingBase'].clearValidate();
        this.$refs['form_Hive'].clearValidate();
      } else if (type === 1) {
        if (this.details.type === 0) {
          this.details.form.mysql.UserName = 'root';
          this.details.form.mysql.Password = '123456';
          this.details.form.mysql.Server = '47.105.165.74';
          this.details.form.mysql.Port = '3306';
          this.details.form.mysql.Catalog = 'visualization';
        } else if (this.details.type === 1) {
          this.details.form.server.UserName = 'sa';
          this.details.form.server.Password = '123456';
          this.details.form.server.Server = '192.168.1.200';
          this.details.form.server.Catalog = 'DncZeus';
        } else if (this.details.type === 2) {
          this.details.form.oracle.UserName = 'JHY';
          this.details.form.oracle.Password = '123456';
          this.details.form.oracle.Server = '192.168.1.200';
          this.details.form.oracle.Port = '1521';
          this.details.form.oracle.Catalog = 'ORCL';
        }
        this.$refs['form_mysql'].clearValidate();
        this.$refs['form_server'].clearValidate();
        this.$refs['form_oracle'].clearValidate();
      }
    },
    //上传之前
    getUploadBefore(file) {
      if (file) {
        this.uploadForm.excel.file = file;
      } else {
        this.uploadForm.excel.file = {};
      }
      return false;
    },
    getUploadBefore2(file) {
      if (file) {
        this.uploadForm.csv.file = file;
      } else {
        this.uploadForm.csv.file = {};
      }
      return false;
    },
    //表单校验
    getFormCheck() {
      let bool = false;
      if (this.uploadForm.radio === 3) {
        if (JSON.stringify(this.uploadForm.excel.file) !== '{}') {
          return true;
        } else {
          return false;
        }
      } else if (this.uploadForm.radio === 6) {
        if (JSON.stringify(this.uploadForm.csv.file) !== '{}') {
          return true;
        } else {
          return false;
        }
      } {
        let formName = '';
        if (this.uploadForm.radio === 0) {
          formName = 'form_mysql';
        } else if (this.uploadForm.radio === 1) {
          formName = 'form_server';
        } else if (this.uploadForm.radio === 2) {
          formName = 'form_oracle';
        } else if (this.uploadForm.radio === 4) {
          formName = 'form_DaMeng';
        } else if (this.uploadForm.radio === 5) {
          formName = 'form_KingBase';
        } else if (this.uploadForm.radio === 7) {
          formName = 'form_Hive';
        }
        if (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              bool = true;
            }
          });
        }
      }
      return bool;
    },
    //测试连接
    getTestSave() {
      if (!this.getFormCheck()) {
        this.getMsg('请完善保存参数!');
        return;
      }
      if (this.uploadForm.radio === 0) {
        MySqlConnText(this.uploadForm.mysql).then(res => {
          if (res.code === 200) {
            this.getAlertSave(0);
            this.add.dialog = false;
          }
        })
      } else if (this.uploadForm.radio === 1) {
        SqlServerConnText(this.uploadForm.server).then(res => {
          if (res.code === 200) {
            this.getAlertSave(1);
            this.add.dialog = false;
          }
        })
      } else if (this.uploadForm.radio === 2) {
        OraConnText(this.uploadForm.oracle).then(res => {
          if (res.code === 200) {
            this.getAlertSave(2);
            this.add.dialog = false;
          }
        })
      } else if (this.uploadForm.radio === 3) {
        let form = new FormData();
        form.append("file", this.uploadForm.excel.file);
        this.uploadForm.excel.filePath = '';
        ExcelConnTestAsync(form).then(res => {
          if (res.code === 200) {
            this.uploadForm.excel.filePath = res.data.filePath;
            this.uploadForm.excel.fileName = res.data.fileName;
            this.getAlertSave(3);
            this.add.dialog = false;
          }
        })
      } if (this.uploadForm.radio === 4) {
        DaMengConnText(this.uploadForm.DaMeng).then(res => {
          if (res.code === 200) {
            this.getAlertSave(4);
            this.add.dialog = false;
          }
        })
      } if (this.uploadForm.radio === 5) {
        KingBaseConnText(this.uploadForm.KingBase).then(res => {
          if (res.code === 200) {
            this.getAlertSave(5);
            this.add.dialog = false;
          }
        })
      } if (this.uploadForm.radio === 6) {
        let form = new FormData();
        form.append("file", this.uploadForm.csv.file);
        this.uploadForm.csv.filePath = '';
        ExcelConnTestAsync(form).then(res => {
          if (res.code === 200) {
            this.uploadForm.csv.filePath = res.data.filePath;
            this.uploadForm.csv.fileName = res.data.fileName;
            this.getAlertSave(6);
            this.add.dialog = false;
          }
        })
      } if (this.uploadForm.radio === 7) {
        HiveConnText(this.uploadForm.Hive).then(res => {
          if (res.code === 200) {
            this.getAlertSave(7);
            this.add.dialog = false;
          }
        })
      }
    },
    //数据接入名称弹框
    getAlertSave(type) {
      this.$alert('测试连接成功 是否【保存】数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        customClass: 'alert_allCom',
      }).then(() => {
        this.$prompt('数据接入名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnPressEscape: false,
          closeOnClickModal: false,
          customClass: 'alert_allCom',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              if (!instance.inputValue) {
                this.getMsg('请输入数据接入名称');
              } else {
                if (await this.getNameRepeat(instance.inputValue)) {
                  done();
                }
              }
              return false;
            } else {
              done();
            }
          }
        }).then(({ value }) => {
          this.getSave(type, value);
        }).catch(() => {

        });
      }).catch(() => {

      });
    },
    //保存成功
    async getSave(type, name) {
      let data = {};
      if (type === 0) {
        data = {
          Type: 1,
          DateSourceName: name,
          UserName: this.uploadForm.mysql.userid,
          Password: this.uploadForm.mysql.password,
          Server: this.uploadForm.mysql.Server,
          Catalog: this.uploadForm.mysql.Catalog,
          Port: this.uploadForm.mysql.port,
        }
      } else if (type === 1) {
        data = {
          Type: 2,
          DateSourceName: name,
          UserName: this.uploadForm.server.userid,
          Password: this.uploadForm.server.password,
          Server: this.uploadForm.server.Server,
          Catalog: this.uploadForm.server.Catalog,
          Port: this.uploadForm.server.port,

        }
      } else if (type === 2) {
        data = {
          Type: 3,
          DateSourceName: name,
          UserName: this.uploadForm.oracle.userid,
          Password: this.uploadForm.oracle.password,
          Server: this.uploadForm.oracle.Server,
          Catalog: this.uploadForm.oracle.Catalog,
          Port: this.uploadForm.oracle.port,
        }
      } else if (type === 3) {
        data = {
          Type: 0,
          DateSourceName: name,
          FilePath: this.uploadForm.excel.filePath,
          FileName: this.uploadForm.excel.fileName,
          password: ''
        }
      } else if (type === 4) {
        data = {
          Type: 4,
          DateSourceName: name,
          UserName: this.uploadForm.DaMeng.userid,
          Password: this.uploadForm.DaMeng.password,
          Server: this.uploadForm.DaMeng.Server,
          Catalog: this.uploadForm.DaMeng.Catalog,
          Port: this.uploadForm.DaMeng.port,
        }
      } else if (type === 5) {
        data = {
          Type: 5,
          DateSourceName: name,
          UserName: this.uploadForm.KingBase.userid,
          Password: this.uploadForm.KingBase.password,
          Server: this.uploadForm.KingBase.Server,
          Catalog: this.uploadForm.KingBase.Catalog,
          Port: this.uploadForm.KingBase.port,
        }
      } else if (type === 6) {
        data = {
          Type: 6,
          DateSourceName: name,
          FilePath: this.uploadForm.csv.filePath,
          FileName: this.uploadForm.csv.fileName,
          password: ''
        }
      } else if (type === 7) {
        data = {
          Type: 7,
          DateSourceName: name,
          UserName: this.uploadForm.Hive.userid,
          Password: this.uploadForm.Hive.password,
          Server: this.uploadForm.Hive.Server,
          Catalog: this.uploadForm.Hive.Catalog,
          Port: this.uploadForm.Hive.port,
        }
      }
      SaveDataSource(data).then(res => {
        if (res.code === 200) {
          this.getMsg(res.message, 'success');
          this.getDataSoureList();
        }
      })
    },
    //数据接入名称重复校验
    async getNameRepeat(name, type) {
      if (type === 1) {
        let data = JSON.parse(this.details.oldStr);
        if (this.details.type === 0) {
          if (data.dateSourceName === this.details.form.mysql.DateSourceName) return true;
        } else if (this.details.type === 1) {
          if (data.dateSourceName === this.details.form.server.DateSourceName) return true;
        } else if (this.details.type === 2) {
          if (data.dateSourceName === this.details.form.oracle.DateSourceName) return true;
        } else if (this.details.type === 3) {
          if (data.dateSourceName === this.details.form.excel.DateSourceName) return true;
        } else if (this.details.type === 4) {
          if (data.dateSourceName === this.details.form.DaMeng.DateSourceName) return true;
        } else if (this.details.type === 5) {
          if (data.dateSourceName === this.details.form.KingBase.DateSourceName) return true;
        } else if (this.details.type === 6) {
          if (data.dateSourceName === this.details.form.csv.DateSourceName) return true;
        } else if (this.details.type === 7) {
          if (data.dateSourceName === this.details.form.Hive.DateSourceName) return true;
        }
      }
      let bool = false;
      await GetDataSourceNameVerify({ dataSourceName: name }).then(res => {
        if (res.code === 200) {
          bool = true;
        }
      });
      return bool;
    },
    //数据接入列表 数据形式
    getTableType(row) {
      if (row.type === 0) {
        return 'EXCEL'
      } else if (row.type === 1) {
        return 'MYSQL'
      } else if (row.type === 2) {
        return 'SQL SERVE'
      } else if (row.type === 3) {
        return 'ORACLE'
      } else if (row.type === 4) {
        return '达梦'
      } else if (row.type === 5) {
        return '金仓'
      } else if (row.type === 6) {
        return 'CSV'
      } else if (row.type === 7) {
        return 'Hive'
      } else {
        return '未知'
      }
    },
    //获取数据接入列表
    getDataSoureList() {
      this.tableCheck.checkList = [];
      this.tableData.load = true;
      GetDataSourceTableList({
        pageIndex: this.tableData.pageIndex,
        pageSize: this.tableData.pageSize,
      }).then(res => {
        if (res.code === 200) {
          this.tableData.list = res.data.dataTabel;
          this.tableData.total = res.data.totalCount;
        }
        this.tableData.load = false;
      }).catch(() => {
        this.tableData.load = false;
      })
    },
    //表格 选中
    getTableCheck(val) {
      this.tableCheck.checkList = val;
    },
    //分页回调
    getPage(index, size) {
      this.tableData.pageIndex = index;
      this.tableData.pageSize = size;
      this.getDataSoureList();
    },
    //详情弹框
    async detailsDialog(type, row) {
      if (type === 0) {
        this.details.oldStr = '';
        this.details.title = row.dateSourceName;
        await GetDataSourceByDataSourceId({
          dataSourceId: row.id
        }).then(res => {
          if (res.code === 200) {
            let data = res.data.dataTabel;
            this.details.oldStr = JSON.stringify(res.data.dataTabel);
            if (data.type === 0) {
              this.details.type = 3;
              this.details.form.excel.ID = data.id;
              this.details.form.excel.DateSourceName = data.dateSourceName;
              this.details.form.excel.Type = data.type;
              this.details.form.excel.filePath = data.filePath;
              this.details.form.excel.FileName = data.fileName;
            } else if (data.type === 1) {
              this.details.type = 0;
              this.details.form.mysql = {
                ID: data.id,
                Type: data.type,
                DateSourceName: data.dateSourceName,
                UserName: data.userName,
                Password: data.password,
                Server: data.server,
                Port: data.port,
                Catalog: data.catalog,
              }
            } else if (data.type === 2) {
              this.details.type = 1;
              this.details.form.server = {
                ID: data.id,
                Type: data.type,
                DateSourceName: data.dateSourceName,
                UserName: data.userName,
                Password: data.password,
                Server: data.server,
                Port: data.port,
                Catalog: data.catalog,
              }
            } else if (data.type === 3) {
              this.details.type = 2;
              this.details.form.oracle = {
                ID: data.id,
                Type: data.type,
                DateSourceName: data.dateSourceName,
                UserName: data.userName,
                Password: data.password,
                Server: data.server,
                Port: data.port,
                Catalog: data.catalog,
              }
            } else if (data.type === 4) {
              this.details.type = 4;
              this.details.form.DaMeng = {
                ID: data.id,
                Type: data.type,
                DateSourceName: data.dateSourceName,
                UserName: data.userName,
                Password: data.password,
                Server: data.server,
                Port: data.port,
                Catalog: data.catalog,
              }
            } else if (data.type === 5) {
              this.details.type = 5;
              this.details.form.KingBase = {
                ID: data.id,
                Type: data.type,
                DateSourceName: data.dateSourceName,
                UserName: data.userName,
                Password: data.password,
                Server: data.server,
                Port: data.port,
                Catalog: data.catalog,
              }
            } if (data.type === 6) {
              this.details.type = 6;
              this.details.form.csv.ID = data.id;
              this.details.form.csv.DateSourceName = data.dateSourceName;
              this.details.form.csv.Type = data.type;
              this.details.form.csv.filePath = data.filePath;
              this.details.form.csv.FileName = data.fileName;
            }else if (data.type === 7) {
              this.details.type = 7;
              this.details.form.Hive = {
                ID: data.id,
                Type: data.type,
                DateSourceName: data.dateSourceName,
                UserName: data.userName,
                Password: data.password,
                Server: data.server,
                Port: data.port,
                Catalog: data.catalog,
              }
            }
            this.details.upd = false;
            this.details.dialog = true;
          }
        });
      } else if (type === 1) {
        this.details.dialog = false;
        this.details.upd = false;
        this.details.title = '';
        this.getDetailNullForm();
      }
    },
    //详情弹框 表单校验
    getDetailFormCheck() {
      let bool = false;
      if (this.details.type === 3) {
        if (JSON.stringify(this.details.form.excel.file) !== '{}') {
          return true;
        } else {
          return false;
        }
      } else if (this.details.type === 6) {
        if (JSON.stringify(this.details.form.csv.file) !== '{}') {
          return true;
        } else {
          return false;
        }
      } else {
        let formName = '';
        if (this.details.type === 0) {
          formName = 'details_mysql';
        } else if (this.details.type === 1) {
          formName = 'details_server';
        } else if (this.details.type === 2) {
          formName = 'details_oracle';
        } else if (this.details.type === 4) {
          formName = 'details_DaMeng';
        } else if (this.details.type === 5) {
          formName = 'details_KingBase';
        }else if (this.details.type === 5) {
          formName = 'details_Hive';
        }
        if (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              bool = true;
            }
          });
        }
      }
      return bool;
    },
    //详情弹框 清空表单
    getDetailNullForm() {
      this.details.form = {
        mysql: {
          ID: '',
          Type: 1,
          DateSourceName: '',
          UserName: '',
          Password: '',
          Server: '',
          Port: '',
          Catalog: '',
        },
        server: {
          ID: '',
          Type: 2,
          DateSourceName: '',
          UserName: '',
          Password: '',
          Server: '',
          Catalog: '',
        },
        oracle: {
          ID: '',
          Type: 3,
          DateSourceName: '',
          UserName: '',
          Password: '',
          Server: '',
          Port: '',
          Catalog: '',
        },
        excel: {
          ID: '',
          Type: 4,
          DateSourceName: '',
          file: {},
          filePath: ''
        },
        DaMeng: {
          ID: '',
          Type: 5,
          DateSourceName: '',
          UserName: '',
          Password: '',
          Server: '',
          Port: '',
          Catalog: '',
        },
        KingBase: {
          ID: '',
          Type: 6,
          DateSourceName: '',
          UserName: '',
          Password: '',
          Server: '',
          Port: '',
          Catalog: '',
        },
        csv: {
          ID: '',
          Type: 7,
          DateSourceName: '',
          file: {},
          filePath: ''
        },
        Hive: {
          ID: '',
          Type: 8,
          DateSourceName: '',
          UserName: '',
          Password: '',
          Server: '',
          Port: '',
          Catalog: '',
        },
      };
      this.$refs['details_mysql'].clearValidate();
      this.$refs['details_server'].clearValidate();
      this.$refs['details_oracle'].clearValidate();
      this.$refs['details_DaMeng'].clearValidate();
      this.$refs['details_KingBase'].clearValidate();
      this.$refs['details_Hive'].clearValidate();
    },
    //详情弹框 重置
    getDetailCancel() {
      this.getDetailNullForm();
      let data = JSON.parse(this.details.oldStr);
      if (data.type === 0) {
        this.details.type = 3;
        this.details.form.excel.ID = data.id;
        this.details.form.excel.DateSourceName = data.dateSourceName;
        this.details.form.excel.Type = data.type;
        this.details.form.excel.filePath = data.filePath;
        this.details.form.excel.FileName = data.fileName;
      } else if (data.type === 1) {
        this.details.type = 0;
        this.details.form.mysql = {
          ID: data.id,
          Type: data.type,
          DateSourceName: data.dateSourceName,
          UserName: data.userName,
          Password: data.password,
          Server: data.server,
          Port: data.port,
          Catalog: data.catalog,
        }
      } else if (data.type === 2) {
        this.details.type = 1;
        this.details.form.server = {
          ID: data.id,
          Type: data.type,
          DateSourceName: data.dateSourceName,
          UserName: data.userName,
          Password: data.password,
          Server: data.server,
          Catalog: data.catalog,
        }
      } else if (data.type === 3) {
        this.details.type = 2;
        this.details.form.oracle = {
          ID: data.id,
          Type: data.type,
          DateSourceName: data.dateSourceName,
          UserName: data.userName,
          Password: data.password,
          Server: data.server,
          Port: data.port,
          Catalog: data.catalog,
        }
      } else if (data.type === 4) {
        this.details.type = 4;
        this.details.form.DaMeng = {
          ID: data.id,
          Type: data.type,
          DateSourceName: data.dateSourceName,
          UserName: data.userName,
          Password: data.password,
          Server: data.server,
          Port: data.port,
          Catalog: data.catalog,
        }
      } else if (data.type === 5) {
        this.details.type = 5;
        this.details.form.KingBase = {
          ID: data.id,
          Type: data.type,
          DateSourceName: data.dateSourceName,
          UserName: data.userName,
          Password: data.password,
          Server: data.server,
          Port: data.port,
          Catalog: data.catalog,
        }
      } else if (data.type === 6) {
        this.details.type = 6;
        this.details.form.csv.ID = data.id;
        this.details.form.csv.DateSourceName = data.dateSourceName;
        this.details.form.csv.Type = data.type;
        this.details.form.csv.filePath = data.filePath;
        this.details.form.csv.FileName = data.fileName;
      }else if (data.type === 5) {
        this.details.type = 5;
        this.details.form.Hive = {
          ID: data.id,
          Type: data.type,
          DateSourceName: data.dateSourceName,
          UserName: data.userName,
          Password: data.password,
          Server: data.server,
          Port: data.port,
          Catalog: data.catalog,
        }
      }
      this.details.upd = false;
    },
    //修改
    getDetailsUpd() {
      this.details.upd = true;
    },
    //详情弹框 上传
    getDetailsUpload(file) {
      if (file) {
        this.details.form.excel.file = file;
      } else {
        this.details.form.excel.file = {};
      }
      return false;
    },
    getDetailsUpload2(file) {
      if (file) {
        this.details.form.csv.file = file;
      } else {
        this.details.form.csv.file = {};
      }
      return false;
    },
    //详情弹框 保存
    getDetailTestUpd() {
      if (!this.getDetailFormCheck()) {
        this.getMsg('请完善保存参数!');
        return;
      }
      let data = {};
      if (this.details.type === 0) {
        data = {
          Server: this.details.form.mysql.Server,
          port: this.details.form.mysql.Port,
          userid: this.details.form.mysql.UserName,
          password: this.details.form.mysql.Password,
          Catalog: this.details.form.mysql.Catalog,
        };
        MySqlConnText(data).then(res => {
          if (res.code === 200) {
            this.getDetiailAlertSave();
          }
        })
      } else if (this.details.type === 1) {
        data = {
          Server: this.details.form.server.Server,
          userid: this.details.form.server.UserName,
          password: this.details.form.server.Password,
          Catalog: this.details.form.server.Catalog,
        };
        SqlServerConnText(data).then(res => {
          if (res.code === 200) {
            this.getDetiailAlertSave();
          }
        })
      } else if (this.details.type === 2) {
        data = {
          Server: this.details.form.oracle.Server,
          port: this.details.form.oracle.Port,
          userid: this.details.form.oracle.UserName,
          password: this.details.form.oracle.Password,
          Catalog: this.details.form.oracle.Catalog,
        };
        OraConnText(data).then(res => {
          if (res.code === 200) {
            this.getDetiailAlertSave();
          }
        })
      } else if (this.details.type === 3) {
        let form = new FormData();
        form.append("file", this.details.form.excel.file);
        this.details.form.excel.filePath = '';
        this.details.form.excel.FileName = '';
        ExcelConnTestAsync(form).then(res => {
          if (res.code === 200) {
            this.details.form.excel.filePath = res.data.filePath;
            this.details.form.excel.FileName = res.data.fileName;
            this.getDetiailAlertSave();
          }
        })
      } else if (this.details.type === 4) {
        data = {
          Server: this.details.form.DaMeng.Server,
          port: this.details.form.DaMeng.Port,
          userid: this.details.form.DaMeng.UserName,
          password: this.details.form.DaMeng.Password,
          Catalog: this.details.form.DaMeng.Catalog,
        };
        DaMengConnText(data).then(res => {
          if (res.code === 200) {
            this.getDetiailAlertSave();
          }
        })
      } else if (this.details.type === 5) {
        data = {
          Server: this.details.form.KingBase.Server,
          port: this.details.form.KingBase.Port,
          userid: this.details.form.KingBase.UserName,
          password: this.details.form.KingBase.Password,
          Catalog: this.details.form.KingBase.Catalog,
        };
        KingBaseConnText(data).then(res => {
          if (res.code === 200) {
            this.getDetiailAlertSave();
          }
        })
      } else if (this.details.type === 6) {
        let form = new FormData();
        form.append("file", this.details.form.csv.file);
        this.details.form.csv.filePath = '';
        this.details.form.csv.FileName = '';
        ExcelConnTestAsync(form).then(res => {
          if (res.code === 200) {
            this.details.form.csv.filePath = res.data.filePath;
            this.details.form.csv.FileName = res.data.fileName;
            this.getDetiailAlertSave();
          }
        })
      }else if (this.details.type === 7) {
        data = {
          Server: this.details.form.Hive.Server,
          port: this.details.form.Hive.Port,
          userid: this.details.form.Hive.UserName,
          password: this.details.form.Hive.Password,
          Catalog: this.details.form.Hive.Catalog,
        };
        HiveConnText(data).then(res => {
          if (res.code === 200) {
            this.getDetiailAlertSave();
          }
        })
      }
    },
    //详情弹框 提示弹框
    getDetiailAlertSave() {
      this.$alert('测试连接成功 是否【修改】数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        customClass: 'alert_allCom',
      }).then(() => {
        this.getDetiailSave();
      }).catch(() => {

      });
    },
    //详情弹框 弹框保存
    async getDetiailSave() {
      let data = {};
      if (this.details.type === 0) {
        if (!await this.getNameRepeat(this.details.form.mysql.DateSourceName, 1)) {
          return;
        }
        data = this.details.form.mysql;
      } else if (this.details.type === 1) {
        if (!await this.getNameRepeat(this.details.form.server.DateSourceName, 1)) {
          return;
        }
        data = this.details.form.server;
      } else if (this.details.type === 2) {
        if (!await this.getNameRepeat(this.details.form.oracle.DateSourceName, 1)) {
          return;
        }
        data = this.details.form.oracle;
      } else if (this.details.type === 3) {
        if (!await this.getNameRepeat(this.details.form.excel.DateSourceName, 1)) {
          return;
        }
        data = {
          ID: this.details.form.excel.ID,
          Type: this.details.form.excel.Type,
          DateSourceName: this.details.form.excel.DateSourceName,
          FilePath: this.details.form.excel.filePath,
          FileName: this.details.form.excel.FileName,
          password: ''
        }
      } else if (this.details.type === 4) {
        if (!await this.getNameRepeat(this.details.form.DaMeng.DateSourceName, 1)) {
          return;
        }
        data = this.details.form.DaMeng;
      } else if (this.details.type === 5) {
        if (!await this.getNameRepeat(this.details.form.KingBase.DateSourceName, 1)) {
          return;
        }
        data = this.details.form.KingBase;
      } else if (this.details.type === 6) {
        if (!await this.getNameRepeat(this.details.form.csv.DateSourceName, 1)) {
          return;
        }
        data = {
          ID: this.details.form.csv.ID,
          Type: this.details.form.csv.Type,
          DateSourceName: this.details.form.csv.DateSourceName,
          FilePath: this.details.form.csv.filePath,
          FileName: this.details.form.csv.FileName,
          password: ''
        }
      }else if (this.details.type === 7) {
        if (!await this.getNameRepeat(this.details.form.Hive.DateSourceName, 1)) {
          return;
        }
        data = this.details.form.Hive;
      }
      SaveDataSource(data).then(res => {
        if (res.code === 200) {
          this.getMsg(res.message, 'success');
          this.getDataSoureList();
          this.detailsDialog(1);
        }
      })
    },
    //详情弹框 跳转
    getRoutePush(row) {
      this.getSoSet(0, row.id);
      this.$router.push('/dataSet');
    },
    //删除
    getRemove() {
      let ids = this.tableCheck.checkList.map((item) => item.id);
      let isStr = ids.join(',');
      this.$alert('是否删除数据接入?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        customClass: 'alert_allCom',
      }).then(() => {
        RemoveDataSource({ dataSourceId: isStr }).then(res => {
          if (res.code === 200) {
            this.getMsg(res.message, 'success');
            this.getDataSoureList();
          }
        })
      }).catch(() => {

      });
    },

    getDemo() {

    },
  },
  mounted() {
    this.init();
    this.getDemo();
  },
  destroyed() {

  }
}
</script>
<style lang="less">
.dataSource {
  height: 100%;
  position: relative;
  // background-color: @h_main_backColor !important;
  padding: 0 !important;
  display: grid;
  grid-template-columns: 230px auto;

  .countB {
    width: calc((100% - 1%) / 2);
    height: 100%;
    display: inline-block;
    // float: left;
    border-radius: 10px;
    padding: 20px;
  }

  .leftSource {
    margin-right: 1%;
    overflow: auto;
    // width: 11%;
    min-width: 210px;
  }

  .rightSource {
    overflow: auto;
    width: 99%;
    margin-right: 1%;
    background-color: #e0e1ec;

    .rigS_til {
      width: 100%;
      display: inline-block;

      .FSpanTil {
        float: left;
        max-width: 70%;
      }

      .add_del {
        float: right;
        // .add_btn{
        //     background-color: #39ae78;
        // }
      }
    }

    .rigS_table {
      width: 100%;
      height: calc(100% - 50px);
      margin-top: 8px;

      .el-table {
        width: 100%;
        height: calc(100% - 60px);
        box-shadow: 0 0 5px 0 rgba(0, 0, 0, 20%);

        .header_check {
          width: 100%;

          .el-checkbox {
            margin-right: 0 !important;
          }

          .el-checkbox__label {
            color: #000 !important;
            letter-spacing: 2px;
            font-size: 16px;
          }
        }

        .checkFirstTab {
          .el-checkbox {
            margin-right: 10px;
          }

          .el-checkbox__label {
            color: #666;
          }
        }

        .table_xq {
          .xqSpan {
            display: inline-block;
            width: 100%;
            cursor: pointer;
            line-height: 20px;
            text-align: center;

            > span {
              color: @green;
              display: inline-block;
            }
          }

          .xqSpan:hover {
            > span {
              border-bottom: 1px solid;
            }
          }
        }

        .table_route {
          .routeDiv {
            display: inline-block;
            width: 100%;
            cursor: pointer;
            line-height: 20px;
            text-align: center;

            > div {
              display: inline-block;
              width: auto;
              height: auto;
            }
          }
        }
      }

      .FPage {
        margin-top: 15px;
      }
    }
  }

  .details_dialog {
    .el-dialog {
      .details_dialog_form {
        padding: 10px 0;
        position: relative;

        .el-form {
          width: 100%;
          height: 100%;
          padding: 20px 0 20px 0;
        }

        .btnRight {
          text-align: center;
          margin-top: 15px;
        }
      }
      .el-dialog__body {
        padding: 0 !important;
      }
    }
    .database {
      width: 100%;
      .kind {
        width: 100%;
        padding: 22px 116px;
        border-bottom: 1px dashed #dcdcdc;
        .el-radio-group {
          width: 100%;
        }
        use {
          width: 16px;
          height: 16px;
          display: inline-block;
        }
      }
      .kind:last-child {
        margin-bottom: 20px;
        border-bottom: 1px solid #dcdcdc;
      }
      .el-radio__inner {
        display: none;
      }
    }
  }
  .btnCenter {
    text-align: center;
    margin: 20px 0;
  }
}
.details_dialog .el-radio__input.is-checked + .el-radio__label {
  color: #fff;
  background: #1d224c;
}
.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 85%;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  margin-right: 10px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.countForm {
  .el-input__inner {
    border: none;
    border-radius: 0px;
    border-bottom: 1px solid #ccc;
    width: 60%;
  }
  .el-form-item {
    margin-left: 100px;
  }
}
.icon-excel {
  color: #23b08d;
}
.icon-CSV {
  color: #34a89f;
}
.icon-connection-Other {
  color: #558bad;
  font-size: 14px;
}
.icon-db_mysql_server {
  color: #40d1e7;
}
.icon-oracle {
  color: #ec494c;
}
.icon-tidb {
  color: #5cb1ff;
}
.icon-rendajincang {
  color: #3c78ff;
}
.icon-damengshujuku {
  color: #1d2683;
  font-size: 18px;
}
.icon-hadoop {
  color: #ffff00;
}
.icon-Hive {
  color: #fdee21;
}
.icon-renkouzengchangshuai {
  color: #1296db;
}
.icon-GlobalGDPquanyuGDP {
  color: #01d3fe;
}
.upload-demo {
  text-align: center;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
